module.exports = __webpack_public_path__ + "static/media/refresh-orange.4e243754.svg";